const FormatKey = ({name}) => {
  	const str = name.replace(/_/g, " ");
   	return str.charAt(0).toUpperCase() + str.slice(1);
};

export default FormatKey